import {
  AgencyIcon,
  Col,
  Etiqueta,
  EtiquetasStyle,
  Modal,
  ModalSizes,
  Row,
  ScreenSize,
  useScreenSize,
} from 'plataforma-fundacao-componentes';
import styles from './styles.module.scss';
import { Fragment, useCallback } from 'react';
import { FlagColaborador } from 'helpers/enums/TipoColaborador';
import { TipoConta } from 'components/Icons';
import { useSelector } from 'react-redux';
import { IReducer } from 'store/Reducer';
import { clsx } from 'helpers/utils/HTMLUtils';
import { languageValues } from 'helpers/utils/languageUtils';
import { ModalProps } from 'plataforma-fundacao-componentes/dist/components/modal/Modal';

export const ConfirmedPresenceNotOnline = (props: ModalProps) => {
  const { currentEvent } = useSelector((state: IReducer) => state.assembleias);

  const handleClose = useCallback(() => {
    props.onClose?.(props.modalKey);
  }, [props]);

  const { rankedSize: screenSize } = useScreenSize();

  const getModalityDescription = (
    presentationDescription: string | number | null
  ) => {
    switch (presentationDescription) {
      case 'AGENCIA':
        return 'Agência';
      case 'PRESENCIAL':
        return 'Presencial';
      default:
        return 'Presencial';
    }
  };

  return (
    <Modal
      preventEscExit={props.preventEscExit || false}
      preventMaskExit={props.preventMaskExit || false}
      modalKey={props.modalKey}
      mobileOn={props.mobileOn}
      title={languageValues.modals.confirmedPresenceNotOnline.title}
      className={styles.root}
      onClose={handleClose}
      size={ModalSizes.ExtraLarge}
      compenseColPaddingContent
    >
      <Row>
        <Col>
          <p>{languageValues.modals.confirmedPresenceNotOnline.subTitle}</p>
        </Col>
        <Col>
          <p>{languageValues.modals.confirmedPresenceNotOnline.description}</p>
        </Col>
      </Row>
      <Row>
        {screenSize >= ScreenSize.md ? (
          <Row className={styles.header_container}>
            <Col cols={[2, 2, 2, 2, 2]}>
              <p className={'nunito'}>
                {
                  languageValues.modals.confirmedPresenceNotOnline.tableHead
                    .account
                }
              </p>
            </Col>
            <Col cols={[3, 3, 3, 3, 3]}>
              <p className={'nunito'}>
                {
                  languageValues.modals.confirmedPresenceNotOnline.tableHead
                    .associateName
                }
              </p>
            </Col>
            <Col cols={[2, 2, 2, 2, 2]}>
              <p className={'nunito'}>
                {
                  languageValues.modals.confirmedPresenceNotOnline.tableHead
                    .nucleou
                }
              </p>
            </Col>
            <Col cols={[3, 3, 3, 3, 3]}>
              <p className={'nunito'}>
                {
                  languageValues.modals.confirmedPresenceNotOnline.tableHead
                    .confirmedPresence
                }
              </p>
            </Col>
            <Col cols={[2, 2, 2, 2, 2]}>
              <p className={'nunito'}>
                {
                  languageValues.modals.confirmedPresenceNotOnline.tableHead
                    .date
                }
              </p>
            </Col>
          </Row>
        ) : undefined}
        {(currentEvent?.contasDisponiveis || [])
          .filter((x: any) => typeof x.tipoPresenca === 'string')
          .map((conta) => {
            return (
              <Row className={styles.body_container}>
                {screenSize >= ScreenSize.md ? (
                  <Fragment>
                    <Col
                      cols={[2, 2, 2, 2, 2]}
                      className={styles.conta_container}
                    >
                      <p>{conta.numeroConta}</p>
                    </Col>
                    <Col cols={[3, 3, 3, 3, 3]}>
                      <div className={styles.name_container}>
                        {conta.flgColaborador ===
                          FlagColaborador.Colaborador && <TipoConta />}
                        <p>{conta.nomeAssociado}</p>
                      </div>
                    </Col>
                    <Col
                      cols={[2, 2, 2, 2, 2]}
                      className={styles.nucleo_container}
                    >
                      <p>{conta.numeroNucleo}</p>
                    </Col>
                    <Col cols={[3, 3, 3, 3, 3]}>
                      <Etiqueta
                        theme={EtiquetasStyle.Finalizado}
                        icon={<AgencyIcon />}
                        label={getModalityDescription(conta.tipoPresenca)}
                      />
                    </Col>
                    <Col cols={[2, 2, 2, 2, 2]}>
                      <p style={{ fontSize: '13px' }}>
                        {conta.dataPresenca ? conta.dataPresenca : '-'}
                      </p>
                    </Col>
                  </Fragment>
                ) : (
                  <Fragment>
                    <Row>
                      <Col cols={[8, 8, 8, 8, 8]}>
                        <Row>
                          <Col
                            cols={[6, 6, 6, 6, 6]}
                            className={styles.conta_container}
                          >
                            <p
                              className={clsx([styles.header_mobile, 'nunito'])}
                            >
                              {
                                languageValues.modals.confirmedPresenceNotOnline
                                  .tableHead.account
                              }
                            </p>
                            <p>{conta.numeroConta}</p>
                          </Col>
                          <Col
                            cols={[6, 6, 6, 6, 6]}
                            className={styles.nucleo_container}
                          >
                            <p
                              className={clsx([styles.header_mobile, 'nunito'])}
                            >
                              {
                                languageValues.modals.confirmedPresenceNotOnline
                                  .tableHead.nucleou
                              }
                            </p>
                            <p>{conta.numeroNucleo}</p>
                          </Col>
                          <Col className={styles.name_mobile_container}>
                            <p
                              className={clsx([styles.header_mobile, 'nunito'])}
                            >
                              {
                                languageValues.modals.confirmedPresenceNotOnline
                                  .tableHead.associateName
                              }
                            </p>
                            <div className={styles.name_container}>
                              {conta.flgColaborador ===
                                FlagColaborador.Colaborador && <TipoConta />}
                              <p>{conta.nomeAssociado}</p>
                            </div>
                          </Col>
                        </Row>
                      </Col>
                      <Col
                        cols={[4, 4, 4, 4, 4]}
                        style={{ borderLeft: '1px solid #efefef' }}
                      >
                        <Row>
                          <Col style={{ flexDirection: 'column' }}>
                            <Row>
                              <p
                                className={clsx([
                                  styles.header_mobile,
                                  'nunito',
                                ])}
                              >
                                {
                                  languageValues.modals
                                    .confirmedPresenceNotOnline.tableHead
                                    .confirmedPresence
                                }
                              </p>
                              <Etiqueta
                                theme={EtiquetasStyle.Finalizado}
                                icon={<AgencyIcon />}
                                label={getModalityDescription(
                                  conta.tipoPresenca
                                )}
                              />
                            </Row>
                            <Row>
                              <p
                                className={clsx([
                                  styles.header_mobile,
                                  'nunito',
                                ])}
                              >
                                {
                                  languageValues.modals
                                    .confirmedPresenceNotOnline.tableHead.date
                                }
                              </p>
                              <p>
                                {conta.dataPresenca ? conta.dataPresenca : '-'}
                              </p>
                            </Row>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Fragment>
                )}
              </Row>
            );
          })}
      </Row>
    </Modal>
  );
};
